import { LoadingSpinnerPositionEnum } from "../../Lib/Enums/LoadingSpinnerPositionEnum";
import { RandomHelper } from "../../Lib/Helper/RandomHelper";

export class AxLoading {
    constructor(private _RandomHelper = new RandomHelper()) {}

    private ActiveLoading: ActiveLoading[] = [];

    ShowLoadingIndicatorForMultible(elems: HTMLElement[], transparent?: boolean, position?: LoadingSpinnerPositionEnum) {

        for (let elem of elems) {
            this.ShowLoadingIndicator(elem, transparent, position);
        }
    }

    HideLoadingIndicatorForMultible(elems: HTMLElement[]) {
        for (let elem of elems) {
            this.HideLoadingIndicator(elem);
        }
    }

    ShowLoadingIndicatorGetId(elem: HTMLElement, transparent?: boolean, position?: LoadingSpinnerPositionEnum, prepend?: boolean): string {

        this.ShowLoadingIndicator(elem, transparent, position, prepend);
        const guid = $(elem).data('ax-loading-guid');
        return guid;
    }

    HideLoadingIndicatorWithId(guid: string) {
        let active = this.GetActiveLoading(guid);

        if (active != null) {
            active.target.remove();
            this.ActiveLoading = this.ActiveLoading.filter(x => x.guid != guid);
            return;
        }

        let elem = $("div[ax-loading-guid='" + guid + "']");
        $(elem).find('.loading-spinner').remove();
    }

    ShowLoadingIndicatorGreyBackGround(elem: HTMLElement, position?: LoadingSpinnerPositionEnum, prepend?: boolean) {
        let guid = $(elem).data('ax-loading-guid');
        prepend = prepend || false;

        if (this.GetActiveLoading(guid) != null) {
            return;
        }

        let loadingIndicator = document.createElement('div');
        loadingIndicator.classList.add('ax-loading-spinner');
        loadingIndicator.classList.add('ax-bg-default');

        this.setPosition(loadingIndicator, position);

        if (prepend) {
            $(elem).prepend(loadingIndicator);
        } else {
            $(elem).append(loadingIndicator);
        }

        guid = this._RandomHelper.GetGuid();
        $(elem).data('ax-loading-guid', guid);

        this.ActiveLoading.push({
            guid: guid,
            target: loadingIndicator
        });
    }

    ShowLoadingIndicator(elem: HTMLElement, transparent?: boolean, position?: LoadingSpinnerPositionEnum, prepend?: boolean) {
        let guid = $(elem).data('ax-loading-guid');
        transparent = transparent || false;
        prepend = prepend || false;

        if (this.GetActiveLoading(guid) != null) {
            return;
        }

        let loadingIndicator = document.createElement('div');
        loadingIndicator.classList.add('ax-loading-spinner');

        if (transparent) {
            loadingIndicator.classList.add('ax-loading-spinner--transparent');
        }

        this.setPosition(loadingIndicator, position);

        if (prepend) {
            $(elem).prepend(loadingIndicator);
        } else {
            $(elem).append(loadingIndicator);
        }

        guid = this._RandomHelper.GetGuid();
        $(elem).data('ax-loading-guid', guid);

        this.ActiveLoading.push({
            guid: guid,
            target: loadingIndicator
        });
    }

    private setPosition(loadingIndicator: HTMLDivElement, position: LoadingSpinnerPositionEnum) {
        if (position != null || position != undefined) {
            if (position == LoadingSpinnerPositionEnum.Left) {
                loadingIndicator.classList.add('justify-content-start');
                loadingIndicator.classList.add('ax-pl-2');
            }
            else if (position == LoadingSpinnerPositionEnum.Right) {
                loadingIndicator.classList.add('justify-content-end');
                loadingIndicator.classList.add('ax-pr-2');
            }
            else if (position == LoadingSpinnerPositionEnum.Top) {
                this.setToTop(loadingIndicator);
            }
        }
    }

    ShowLoadingIndicatorButtonPrimary(elem: HTMLElement, transparent?: boolean) {
        let guid = $(elem).data('ax-loading-guid');
        transparent = transparent || false;

        if (this.GetActiveLoading(guid) != null) {
            return;
        }

        let loadingIndicator = document.createElement('div');
        loadingIndicator.classList.add('ax-loading-spinner-button');
        loadingIndicator.classList.add('ax-btn');
        loadingIndicator.classList.add('ax-btn-primary');

        if (transparent) {
            loadingIndicator.classList.add('ax-loading-spinner--transparent');
        }

        $(elem).append(loadingIndicator);
        guid = this._RandomHelper.GetGuid();
        $(elem).data('ax-loading-guid', guid);

        this.ActiveLoading.push({
            guid: guid,
            target: loadingIndicator
        });
    }

    private setToTop(loadingIndicator: any) {
        loadingIndicator.classList.add('d-flex');
        loadingIndicator.classList.add('align-items-start');
        loadingIndicator.classList.add('p-2');
    }

    ShowLoadingIndicatorTop(elem: HTMLElement) {
        let guid = $(elem).data('ax-loading-guid');

        if (this.GetActiveLoading(guid) != null) {
            return;
        }

        let loadingIndicator = document.createElement('div');
        loadingIndicator.classList.add('ax-loading-spinner');
        this.setToTop(loadingIndicator);

        $(elem).append(loadingIndicator);
        guid = this._RandomHelper.GetGuid();
        $(elem).data('ax-loading-guid', guid);

        this.ActiveLoading.push({
            guid: guid,
            target: loadingIndicator
        });
    }

    ShowLoadingIndicatorFixed(elem: HTMLElement) {
        let guid = $(elem).data('ax-loading-guid');

        if (this.GetActiveLoading(guid) != null) {
            return;
        }

        let loadingIndicator = document.createElement('div');
        loadingIndicator.classList.add('ax-loading-spinner');
        loadingIndicator.classList.add('position-fixed');

        $(elem).append(loadingIndicator);
        guid = this._RandomHelper.GetGuid();
        $(elem).data('ax-loading-guid', guid);

        this.ActiveLoading.push({
            guid: guid,
            target: loadingIndicator
        });
    }

    HideLoadingIndicator(elem: HTMLElement) {
        let guid = $(elem).data('ax-loading-guid');
        let active = this.GetActiveLoading(guid);

        if (active != null) {
            active.target.remove();
            this.ActiveLoading = this.ActiveLoading.filter(x => x.guid != guid);
            return;
        }
        $(elem).find('.loading-spinner').remove();
    }

    private GetActiveLoading(guid: string): ActiveLoading {
        if (guid != null) {
            return this.ActiveLoading.find(x => x.guid == guid);
        }
        return null;
    }
}


interface ActiveLoading {
    guid: string;
    target: HTMLElement;
}